import { messages } from "../../i18n/messages.js";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
  onFocus?: () => void;
  className?: string;
}

export function SearchInput({
  value,
  onChange,
  readOnly = false,
  onFocus,
  className = "",
}: SearchInputProps) {
  return (
    <div className={className || "px-4 pt-3"}>
      <input
        type="search"
        value={value}
        readOnly={readOnly}
        onFocus={onFocus}
        onChange={(event) => onChange(event.target.value)}
        placeholder={messages.common.searchPlaceholder}
        aria-label={messages.common.searchPlaceholder}
        className="min-h-11 w-full rounded-[16px] border border-black/10 bg-[var(--tg-theme-secondary-bg-color,#f4f4f5)] px-4 py-3 text-sm outline-none focus:border-[var(--tg-theme-button-color,#3390ec)]"
      />
    </div>
  );
}
